module.exports = __webpack_public_path__ + "fonts/mem5YaGs126MiZpBA-UN7rgOXOhpOqc.63f785f0.woff2";